var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"grid grid-cols-2 gap-x-4 gap-y-6 md:grid-cols-4 md:gap-x-8"},_vm._l((_vm.boutiques),function(boutique){return _c('n-link',{key:boutique.slug,attrs:{"to":_vm.localePath({
        name: 'ville-boutique',
        params: { ville: _vm.getVilleSlug(boutique), boutique: boutique.slug }
      })}},[_c('BoutiqueExerpt',{attrs:{"boutique":boutique}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }